
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as imPawogEKUgO7PfJ5zfqv18H8rKRvQR6Laht3EkMIgK8Meta } from "/opt/buildhome/repo/pages/i.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as OrderokfD_FTzs15mPi9BlRO7MDDn6V13k038NLKHgx9HTvIMeta } from "/opt/buildhome/repo/pages/Order.vue?macro=true";
import { default as OffertalJNziD_45_45VJkcqQ7wxIT8U2G2IsZYPIj_45IpZ7_45jQ8usYMeta } from "/opt/buildhome/repo/pages/Offerta.vue?macro=true";
import { default as ContactsOklPNfsWJBl8OGtNx7MSfLdarfX6vjWKlqs18RYzk1oMeta } from "/opt/buildhome/repo/pages/Contacts.vue?macro=true";
import { default as Delivery6wudF3GzkopJF1uq9_45qEOuCXPMCCbQhlEDyIC2Ld6kIMeta } from "/opt/buildhome/repo/pages/Delivery.vue?macro=true";
import { default as WishlistZ6JGgtN37ks0lz_EESEtWWCdv78FffyglAIgHj9thJ4Meta } from "/opt/buildhome/repo/pages/Wishlist.vue?macro=true";
import { default as CertificateKmy_45PR0feyjmjWX_45ZFPm5yN5NpgLQF5sgE1cHkuFL50Meta } from "/opt/buildhome/repo/pages/Certificate.vue?macro=true";
import { default as _91slug_93XjmmnoaaqoMx3iqC5SdWBVViezx1ZFKFap1mtko_i4AMeta } from "/opt/buildhome/repo/pages/news/[slug].vue?macro=true";
import { default as indexjYLHr6NXjpvFf_gXujeNDoOTZnxcSaS9oAuKnKWOqgoMeta } from "/opt/buildhome/repo/pages/search/index.vue?macro=true";
import { default as return_45poilcyx0MxG53TcYx5UFj_lS_45M9ecohKtIkaqIc_45TwUSj1AT4Meta } from "/opt/buildhome/repo/pages/return-poilcy.vue?macro=true";
import { default as _91slug_93oye_hRWF_DHUX6YX4hNesRy8r7iVNF9PXQIMbQ98k0sMeta } from "/opt/buildhome/repo/pages/thanks/[slug].vue?macro=true";
import { default as _91search_93UAjf28EsH_45WZOn3zsoRlz_NLBMjW7Mhg9JbecIDBatkMeta } from "/opt/buildhome/repo/pages/search/[search].vue?macro=true";
import { default as _91subCategorySlug_93yEYhIIryK2qIYew3nued7xXg6Z2iyL5Gv356nTrRsroMeta } from "/opt/buildhome/repo/pages/catalog/[categoryId]/[subCategorySlug].vue?macro=true";
import { default as _91categoryId_93SQ9cdZ_45l38jquZKgzTuSA7tgceqTn6wdaseJA3F8fa0Meta } from "/opt/buildhome/repo/pages/catalog/[categoryId].vue?macro=true";
import { default as indexGVZow9wvjiIf19GAFtPVsxablqyQT7uHQGggV4ePcJIMeta } from "/opt/buildhome/repo/pages/product/[slug]/index.vue?macro=true";
import { default as _91vendor_code_935Wp_457u3Px_nsSKJDgp_45YzZvc0mpHdvqZlsuVMvS_455hkMeta } from "/opt/buildhome/repo/pages/product/[slug]/[vendor_code].vue?macro=true";
export default [
  {
    name: "i",
    path: "/i",
    component: () => import("/opt/buildhome/repo/pages/i.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "Order",
    path: "/Order",
    component: () => import("/opt/buildhome/repo/pages/Order.vue")
  },
  {
    name: "Offerta",
    path: "/Offerta",
    component: () => import("/opt/buildhome/repo/pages/Offerta.vue")
  },
  {
    name: "Contacts",
    path: "/Contacts",
    component: () => import("/opt/buildhome/repo/pages/Contacts.vue")
  },
  {
    name: "Delivery",
    path: "/Delivery",
    component: () => import("/opt/buildhome/repo/pages/Delivery.vue")
  },
  {
    name: "Wishlist",
    path: "/Wishlist",
    component: () => import("/opt/buildhome/repo/pages/Wishlist.vue")
  },
  {
    name: "Certificate",
    path: "/Certificate",
    component: () => import("/opt/buildhome/repo/pages/Certificate.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/opt/buildhome/repo/pages/news/[slug].vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/opt/buildhome/repo/pages/search/index.vue")
  },
  {
    name: "return-poilcy",
    path: "/return-poilcy",
    component: () => import("/opt/buildhome/repo/pages/return-poilcy.vue")
  },
  {
    name: "thanks-slug",
    path: "/thanks/:slug()",
    component: () => import("/opt/buildhome/repo/pages/thanks/[slug].vue")
  },
  {
    name: "search-search",
    path: "/search/:search()",
    component: () => import("/opt/buildhome/repo/pages/search/[search].vue")
  },
  {
    name: "catalog-categoryId",
    path: "/catalog/:categoryId()",
    component: () => import("/opt/buildhome/repo/pages/catalog/[categoryId].vue"),
    children: [
  {
    name: "catalog-categoryId-subCategorySlug",
    path: ":subCategorySlug()",
    component: () => import("/opt/buildhome/repo/pages/catalog/[categoryId]/[subCategorySlug].vue")
  }
]
  },
  {
    name: "product-slug",
    path: "/product/:slug()",
    component: () => import("/opt/buildhome/repo/pages/product/[slug]/index.vue")
  },
  {
    name: "product-slug-vendor_code",
    path: "/product/:slug()/:vendor_code()",
    component: () => import("/opt/buildhome/repo/pages/product/[slug]/[vendor_code].vue")
  }
]